import { getSelectors } from '@repo/core'
import { editAliasDataSelectorConfig } from './editAlias'
export * from './editAlias'

export const editAliasDataSelector = getSelectors({
  getRootPath: editAliasDataSelectorConfig.editAliasDataSelector.getRootPath,
})
